import { render, staticRenderFns } from "./SurveyStep.vue?vue&type=template&id=0531348c&scoped=true&"
import script from "./SurveyStep.vue?vue&type=script&lang=js&"
export * from "./SurveyStep.vue?vue&type=script&lang=js&"
import style0 from "./SurveyStep.vue?vue&type=style&index=0&id=0531348c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0531348c",
  null
  
)

export default component.exports